import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);

  const navGap = 'clamp(0.9rem, 2vw, 2.4rem)';
  const navFontSize = 'clamp(14px, 1.02vw, 15px)';
  const ctaPaddingInline = 'clamp(1.25rem, 2.2vw, 2.75rem)';
  const ctaFontSize = 'clamp(0.9rem, 1vw, 1.15rem)';

  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  useEffect(() => {
    let lastScrollY = window.scrollY;
    
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isScrollingDown = scrollY > lastScrollY;
      
      setIsCollapsed(isScrollingDown && scrollY > 50);
      setIsAtTop(scrollY === 0);
      lastScrollY = scrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed left-0 right-0 z-50 transition-all duration-[700ms] ease-in-out
      ${isCollapsed ? '-top-[72px] lg:-top-40 lg:scale-[130%] lg:opacity-50' : isAtTop ? 'top-0 lg:top-10' : 'top-0'}
      ${isAtTop ? 'lg:flex lg:justify-center' : 'lg:scale-[100%]'}
      h-[50px] md:h-[60px] xlg:h-[72px]`}>
      <div className={`flex justify-between items-center h-full transition-all duration-[700ms] ease-in-out
        w-full bg-transparent absolute left-0 right-0`}>
        <div className="w-full h-full mx-auto bg-white shadow-md lg:w-[min(92.86%,_1560px)]">
          <div className="flex items-center h-full w-full px-0 font-medium lg:pl-0 lg:pr-0 lg:relative">
          <Link
            to="/"
            className="flex items-center h-full flex-shrink-0 pr-0 lg:pr-0"
            onClick={() => setMobileMenuOpen(false)}
          >
            <img
              src="/images/gtechniq-logo.svg"
              alt="Gtechniq"
              className="block h-full max-h-full w-auto object-contain "
            />
          </Link>
          <nav
            className="hidden lg:flex items-center justify-center min-w-0 lg:absolute lg:left-1/2 lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2"
            style={{ columnGap: navGap }}
          >
            <Link
              to="/produtos"
              className=" text-gray-700 hover:text-[#FF0000] whitespace-nowrap"
              style={{ fontSize: navFontSize }}
              onClick={(event) => {
                try { window.sessionStorage.setItem('visitedProdutos', '1'); } catch {}
                if (location.pathname === '/produtos') {
                  event.preventDefault();
                  const target = document.getElementById('product-showcase');
                  if (target) {
                    target.scrollIntoView({ behavior: 'auto', block: 'start' });
                  }
                }
              }}
            >
              Produtos
            </Link>
            <Link
              to="/encontre-um-profissional"
              className=" text-gray-700 hover:text-[#FF0000] whitespace-nowrap"
              style={{ fontSize: navFontSize }}
            >
              Aplicadores &amp; Revendas
            </Link>
            <Link
              to="/sobre"
              className=" text-gray-700 hover:text-[#FF0000] whitespace-nowrap"
              style={{ fontSize: navFontSize }}
            >
              Sobre
            </Link>
            <Link
              to="/contato"
              className=" text-gray-700 hover:text-[#FF0000] whitespace-nowrap"
              style={{ fontSize: navFontSize }}
            >
              Contato
            </Link>
          </nav>
          <a
            href="https://gtechniq.com.br/loja"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex bg-[#FF0000] text-white font-bold h-full hover:bg-red-600 items-center justify-center tracking-[0.05em] uppercase whitespace-nowrap leading-tight flex-shrink-0 lg:ml-auto lg:relative lg:z-10"
            style={{ paddingInline: ctaPaddingInline, fontSize: ctaFontSize }}
          >
            Loja Online
          </a>
          <button onClick={toggleMobileMenu} className="lg:hidden text-gray-700 ml-auto pr-3">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white py-4 absolute top-full left-0 right-0 shadow-md">
          <div className="container mx-auto px-4">
            <Link
              to="/produtos"
              onClick={(event) => {
                setMobileMenuOpen(false);
                try { window.sessionStorage.setItem('visitedProdutos', '1'); } catch {}
                if (location.pathname === '/produtos') {
                  event.preventDefault();
                  const target = document.getElementById('product-showcase');
                  if (target) {
                    target.scrollIntoView({ behavior: 'auto', block: 'start' });
                  }
                }
              }}
              className="block py-2 text-gray-700 hover:text-[#FF0000]"
            >
              Produtos
            </Link>
            <Link to="/encontre-um-profissional" onClick={() => setMobileMenuOpen(false)} className="block py-2 text-gray-700 hover:text-[#FF0000]">Aplicadores &amp; Revendas</Link>
            <Link to="/sobre" onClick={() => setMobileMenuOpen(false)} className="block py-2 text-gray-700 hover:text-[#FF0000]">Sobre</Link>
            <Link to="/contato" onClick={() => setMobileMenuOpen(false)} className="block py-2 text-gray-700 hover:text-[#FF0000]">Contato</Link>
            <a href="https://gtechniq.com.br/loja" target="_blank" rel="noopener noreferrer" className="block py-2 mt-2 bg-[#FF0000] text-white font-bold px-4 hover:bg-red-600 text-center tracking-[0.15em] uppercase">
              Loja Online
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
